module.exports = __webpack_public_path__ + "resources/e1e9dfd52285a273adf366f7e0abb904.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/construct.png
// module id = 205
// module chunks = 0